module.exports = __webpack_public_path__ + "static/media/2.60866857.png";